module.exports = __webpack_public_path__ + "img/logo_grey.da1b9dd1.svg";